import { useContext } from 'react'

// import "./styles.scss"
import Button from '../Button'
import Card from '../Card/Card'
import { AppContext } from '../../contexts/AppContext'
import { timeSince } from '../../services/format'
import { useHistory } from 'react-router-dom';

export default function TicketsCard({
    ticket,
    clickable = true
}) {
    const { t } = useContext(AppContext)
    const history = useHistory();

    return (
        <Card
            className="min-h-18"
            linkable={clickable}
            onClick={() => clickable ? history.push(`/ticket/${ticket.ticketId}`) : null}
        >
            <div className="card-ticket" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                    <bds-typo variant="fs-14" bold="light" margin={false}>#{ticket.code}</bds-typo>
                    <bds-typo variant="fs-16" bold="light" margin={false}>{ticket.subject}</bds-typo>
                    <bds-typo variant="fs-12" bold="light">Criado {timeSince(ticket.createdAt)} | Última atividade {timeSince(ticket.lastInteraction)}</bds-typo>
                </div>

                <div>
                    <Button
                        variant="solid"
                        color={{
                            "queue": "content",
                            "in-attendance": "content",
                            "waiting-client": "negative",
                            "waiting-blip": "primary",
                            "resolved": "positive",
                            "finished": "positive",
                        }[ticket.status] || "content"}
                        text={{
                            "queue": "Aguardando",
                            "in-attendance": "Em atendimento",
                            "waiting-client": "Aguardando cliente",
                            "waiting-blip": "Aguardando Blip",
                            "resolved": "Resolvido",
                            "finished": "Finalizado",
                        }[ticket.status] || "-"}
                        arrow={false}
                        // disabled={true}
                        onClick={clickable ?
                            () => {
                                history.push(`/ticket/${ticket.ticketId}`)
                            } : () => { }
                        }
                    />
                </div>
            </div>
        </Card>
    )
}